<template>
  <div>
    <!-- 时间筛选 -->
    <el-row style="margin: 15px 0;">
	  <el-radio-group v-model="type" size="medium" style="margin-right: 16px;" @change="changeDateRange">
		<el-radio-button label="1" >本月</el-radio-button>
		<el-radio-button label="2">今年</el-radio-button>
		<el-radio-button label="3">全部</el-radio-button>
	  </el-radio-group>
      <el-date-picker
		  v-model="date_range" type="daterange" size="medium"
		  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
		  value-format="yyyy-MM-dd" @change="dateChange">
      </el-date-picker>
    </el-row>
    <!-- 表格 -->
    <el-table border stripe
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="created_at"
        label="提交时间"
        width="180">
      </el-table-column>
      <el-table-column
        prop="email"
        label="邮箱"
        width="180">
      </el-table-column>
      <el-table-column
        prop="feedback"
        label="留言内容"
        >
		<template slot-scope="scope">
			<span class="content">{{scope.row.feedback}}</span>
			<el-button type="text" class="text-btn" @click="openDetailDialog(scope.row.feedback)">详情</el-button>
		</template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div style="padding: 15px 0; text-align: right;">
      <el-pagination
                     :hide-on-single-page="true" background
                     @current-change="handleCurrentChange"
                     :current-page="pagination.page"
                     :page-size="pagination.page_size"
                     layout="total, prev, pager, next, jumper"
                     :total="pagination.total">
      </el-pagination>
    </div>
    <div style="height: 100px;"></div>
	
	<el-dialog
	  title="留言详情"
	  :visible.sync="detailDialog"
	  width="40%"
	  >
	  <span>{{detail}}</span>
	</el-dialog>
  </div>
</template>
<script>
export default {
  name: "customer-message",
  data() {
    return {
      date_range: ["",""],
      list: [],
      pagination: {
        page: 1, total: 400, page_size: 15,
      },
	  type: 3,
	  detailDialog: false,
	  detail: ''
    }
  },
  methods: {
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.getList();
    },
	dateChange(e) {
		if(!e) {
			this.date_range = ['','']
		}
		this.getList()
	},
    getList() {
      let params = {
        page: this.pagination.page,
        start_date: this.date_range[0],
        end_date: this.date_range[1]
      };
      this.list = [];
      this.$axios.get("feedbacks", params).then(res => {
        this.list = res.data;
        this.pagination.total = res.total;
      });
    },
    openDetailDialog(detail) {
		this.detail = detail
		this.detailDialog = true
	},
    changeDateRange(e) {
		let date = new Date()
		let year = date.getFullYear()
		let month = date.getMonth()+1
		let last = new Date(year,month,0).getDate()
		switch(e) {
			case '1': 
			this.$set(this,'date_range',[`${year}-${month}-01`,`${year}-${month}-${last}`])
			break;
			case '2':
			this.$set(this,'date_range',[`${year}-01-01`,`${year}-12-31`])
			break;
			case '3':
			this.$set(this,'date_range',['',''])
			break;
		}
		this.getList()
	}
  },
  mounted() {
    this.getList();
  }
}
</script>
<style lang="scss" scoped>
	.content-row{
		overflow: hidden;
	}
	.content{
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
		width: calc(100% - 40px);
		overflow: hidden;
		vertical-align: bottom;
	}
	.text-btn{
		padding: 0;
	}
</style>